import { render } from "./instrumentDetail.vue?vue&type=template&id=0d48c62b&scoped=true"
import script from "./instrumentDetail.vue?vue&type=script&lang=js"
export * from "./instrumentDetail.vue?vue&type=script&lang=js"

import "./instrumentDetail.vue?vue&type=style&index=0&id=0d48c62b&scoped=true&lang=css"

import exportComponent from "D:\\code\\vue\\gaoxinTech\\gaoxin_tech1\\gaoxintech\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d48c62b"]])

export default __exports__